import React from 'react';
import {
	COLOR_DRAWER_ICON_CONTACT,
	COLOR_DRAWER_ITEM_HOVER,
	COLOR_DRAWER_ITEM_TEXT,
} from '../../../styles/tokens';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import HelpIcon from '@mui/icons-material/Help';

export const Contact = () => {
	const handleClick = async () => {
		window.location.href = 'mailto:matt@foreedgebookart.com';
	};

	return (
		<ListItem key={'Contact'} disablePadding>
			<ListItemButton
				onClick={handleClick}
				sx={{ '&:hover': { backgroundColor: COLOR_DRAWER_ITEM_HOVER } }}
			>
				<ListItemIcon
					sx={{ color: COLOR_DRAWER_ICON_CONTACT, minWidth: '40px' }}
				>
					<HelpIcon />
				</ListItemIcon>
				<ListItemText
					primary={'Contact'}
					primaryTypographyProps={{
						variant: 'h5',
						sx: { color: COLOR_DRAWER_ITEM_TEXT },
					}}
				/>
			</ListItemButton>
		</ListItem>
	);
};
